<mat-form-field style="width: 100%" appearance="outline">
  <mat-label> {{ label }}</mat-label>
  <input
    matInput
    type="text"
    (input)="onChange($event)"
    [placeholder]="description"
    [id]="id"
    [formControl]="form"
    [matAutocomplete]="auto" />
  <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" (optionSelected)="onSelect($event)">
    @if (loading | async) {
      <mat-option><mat-spinner diameter="30"></mat-spinner></mat-option>
    } @else {
      @for (adminId of filteredOptions | async; track $index) {
        <mat-option [value]="+adminId">{{ getAdminName(+adminId) }}</mat-option>
      }
    }
  </mat-autocomplete>
  @if (selected()) {
    <mat-hint>Selected: {{ currentSelectedAdmin() }}</mat-hint>
  } @else {
    <mat-hint><span class="error-text">{{ error }}!</span> Search by admin name to select</mat-hint>
  }
</mat-form-field>
